import styled from "styled-components";

const CocktailImg = styled.h2`
  text-align: center;
  padding: 20px;
  color: rgba(0, 185, 205, 1);
`;

export default CocktailImg;
